// Angular
import { Routes } from "@angular/router";
// Component
import { LayoutComponent } from "./pages/layout/layout.component";
// Guard
import { AuthGuard } from "../core/auth";

// Shell Routes
export const shellRoutes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        loadChildren: () => import('./../views/pages/home/home.routes').then((m) => m.homeRoutes)
    },
    {
        path: 'refresh',
        loadComponent: () => import('./pages/splash-screen/splash-screen.component').then(m => m.SplashScreenComponent),
    },
    {
        path: 'auth',
        loadChildren: () => import('./../views/pages/auth/auth.routes').then((m) => m.authRoutes)
    },
    {
        path: 'error',
        loadChildren: () => import('./../views/pages/errors/errors.routes').then((m) => m.errorRoutes)
    },
    {
        path: '',
        component: LayoutComponent,
        loadChildren: () => import("./pages/part-search/part-search.routes").then((m) => m.partSearchRoutes)
    },
    {
        path: "saved-parts",
        component: LayoutComponent,
        loadChildren: () => import("./pages/saved-parts/saved-parts.routes").then((m) => m.savedPartsRoutes)
    },
    {
        path: "create-inquiry",
        component: LayoutComponent,
        loadChildren: () => import("./pages/create-inquiry/create-inquiry.routes").then((m) => m.createInquiryRoutes)
    },
    {
        path: "survey",
        component: LayoutComponent,
        loadChildren: () => import("./pages/survey/survey.routes").then((m) => m.surveyRoutes)
    },
    {
        path: "right-of-withdrawal",
        component: LayoutComponent,
        loadChildren: () => import("./pages/right-of-withdrawal/right-of-withdrawal.routes").then((m) => m.withdrawalRoutes)
    },
    {
        path: "ov",
        component: LayoutComponent,
        loadChildren: () => import("./pages/other-part-search/other-part-search.routes").then((m) => m.otherPartSearchRoutes)
    },
    {
        path: "df",
        component: LayoutComponent,
        loadChildren: () => import("./pages/tyre-and-rims-search/tyre-and-rims-search.routes").then((m) => m.tyreAndRimeSearchrRoutes)
    },
    {
        path: "vs",
        component: LayoutComponent,
        loadChildren: () => import("./pages/vehicle-search/vehicle-search.routes").then((m) => m.vehicleSearchRoutes)
    },
    {
        path: "affiliated-companies",
        component: LayoutComponent,
        loadChildren: () => import("./pages/affiliated-companies/affiliated-companies.routes").then((m) => m.affiliatedCompaniesRoutes)
    },
    {
        path: "documents",
        component: LayoutComponent,
        loadChildren: () => import("./pages/documents/document.routes").then((m) => m.documentRoutes)
    },
    {
        path: "contact-us",
        component: LayoutComponent,
        loadChildren: () => import("./pages/contact-us/contact-us.routes").then((m) => m.contactUsRoutes)
    },
    {
        path: "notification",
        component: LayoutComponent,
        loadChildren: () => import("./pages/notification/notification.routes").then((m) => m.notificationRoutes)
    },
    {
        path: "captcha",
        component: LayoutComponent,
        loadChildren: () => import("./pages/captcha/captcha.routes").then((m) => m.captchaRoutes)
    },
    {
        path: "account",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import("./pages/account/account.routes").then((m) => m.accountRoutes)
    },
];